export default "__VITE_ASSET__BdM6f183__"